import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

class FlashNoticeContainer extends Component {
    render(){
        return (
            <ToastContainer style={{marginTop: '50px'}}/>
        );
    }
}

export default FlashNoticeContainer

class CustomFlashNotice extends Component {
    render() {
        return (
            <div>
                <div key="toast-header" style={{textAlign: "center"}}><strong>{this.props.type}</strong></div>
                <div key="toast-msg" style={{textAlign: "center"}}>{this.props.message}</div>
            </div>
        );
    }
}

var flash_notice = function(msg, type) {
    msg = msg || "Internal Error! Please contact Altizon Support!"
    msg = msg.replace("<br/>","\n");
    var commonProps = {
        autoClose: 5000,
        closeOnClick: false,
    }
    switch(type) {
        case 'alert':
        case 'error':
            type = "Error";
            commonProps['type'] = toast.TYPE.ERROR;
            break;
        case 'notice':
        case 'information':
        case 'info':
            type = "Information";
            commonProps['type'] = toast.TYPE.INFO;
            break;
        case 'success':
            type = "Success";
            commonProps['type'] = toast.TYPE.SUCCESS;
            break;
        case 'warning':
            type = "Warning";
            commonProps['type'] = toast.TYPE.WARNING;
            break;
        default:
            type = "Notification";

    }
    toast(<CustomFlashNotice message={msg} type={type} />, commonProps);
}

global.flash_notice = flash_notice;
global.flashNotice = flash_notice;
